import React from "react";
import { format } from "date-fns";

import Spinner from "../../../Components/Spinner";

export const getColumnDefs = (updateDecision) => {
	const columnDefs = [
		{
			field: "decision",
			headerName: "Decision",
			editable: true,
			cellEditor: "agLargeTextCellEditor",
			cellEditorPopup: true,
			cellEditorParams: {
				maxLength: 100_000,
			},
			flex: 1,
			headerCheckboxSelection: true,
			headerCheckboxSelectionFilteredOnly: true,
			checkboxSelection: true,
		},
		{
			field: "created_at",
			headerName: "Date",
			valueGetter: (params) => format(params.data.createdAt, "MM/dd/yyyy"),
			width: 150,
		},
	];

	return columnDefs;
};

export const getContextMenuItems = (params, gridRef, deleteDecisions) => {
	const selectedRows = gridRef.current.api.getSelectedRows();

	return [
		{
			name: `Delete ${selectedRows.length} ${selectedRows.length === 1 ? "item" : "items"}`,
			action: () => {
				deleteDecisions(selectedRows.map((row) => row._id));
			},
		},
		"separator",
		"copy",
		"copyWithHeaders",
		"separator",
		"export",
	];
};

export const getStatusBar = (isLoadingDecisions, isCreatingDecision, isUpdatingDecision, isDeletingDecisions) => {
	const statusBar = {
		statusPanels: [
			{ statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" },
			{ statusPanel: "agTotalRowCountComponent", align: "center" },
			{ statusPanel: "agFilteredRowCountComponent" },
			{ statusPanel: "agSelectedRowCountComponent" },
			{ statusPanel: "agAggregationComponent" },
			{
				statusPanel: () => {
					if (isLoadingDecisions || isCreatingDecision || isUpdatingDecision || isDeletingDecisions) {
						return (
							<div className="ag-status-name-value ag-status-panel ag-status-panel-selected-row-count">
								<Spinner size={20} />
							</div>
						);
					}

					return null;
				},
			},
		],
	};

	return statusBar;
};
